let weixinSdkPromise = null;

function loadWeixinSdk() {
    if (typeof window === "undefined" || typeof document === "undefined") return Promise.resolve(null);
    if (globalThis.wx) return Promise.resolve(globalThis.wx);
    if (weixinSdkPromise) return weixinSdkPromise;

    weixinSdkPromise = new Promise((resolve, reject) => {
        const timer = window.setTimeout(() => resolve(globalThis.wx || null), 3000);
        const finish = (handler, value) => {
            window.clearTimeout(timer);
            handler(value);
        };
        const existed = document.querySelector('script[data-miniprogram-jssdk="true"]');
        if (existed) {
            existed.addEventListener("load", () => finish(resolve, globalThis.wx || null), { once: true });
            existed.addEventListener("error", (error) => finish(reject, error), { once: true });
            return;
        }

        const script = document.createElement("script");
        script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
        script.async = true;
        script.dataset.miniprogramJssdk = "true";
        script.onload = () => finish(resolve, globalThis.wx || null);
        script.onerror = (error) => finish(reject, error);
        document.head.appendChild(script);
    });

    return weixinSdkPromise;
}

export function getMiniProgramBridge() {
    return globalThis.wx?.miniProgram || null;
}

export function postMiniProgramMessage(message) {
    const bridge = getMiniProgramBridge();
    if (bridge?.postMessage) {
        bridge.postMessage({ data: message });
        return;
    }

    loadWeixinSdk()
        .then(() => getMiniProgramBridge()?.postMessage?.({ data: message }))
        .catch((error) => {
            console.warn("[miniprogram-bridge] postMessage failed", error);
        });
}

export function navigateMiniProgram(url) {
    const bridge = getMiniProgramBridge();
    if (bridge?.navigateTo) {
        bridge.navigateTo({ url });
        return true;
    }

    loadWeixinSdk()
        .then(() => {
            const loadedBridge = getMiniProgramBridge();
            if (!loadedBridge?.navigateTo) {
                console.warn("[miniprogram-bridge] wx.miniProgram.navigateTo unavailable", url);
                return;
            }
            loadedBridge.navigateTo({ url });
        })
        .catch((error) => {
            console.warn("[miniprogram-bridge] navigateTo failed", error);
        });
    return false;
}

export function reLaunchMiniProgram(url) {
    const bridge = getMiniProgramBridge();
    if (bridge?.reLaunch) {
        bridge.reLaunch({ url });
        return;
    }
    if (bridge?.navigateTo) {
        bridge.navigateTo({ url });
        return;
    }

    loadWeixinSdk()
        .then(() => {
            const loadedBridge = getMiniProgramBridge();
            if (loadedBridge?.reLaunch) {
                loadedBridge.reLaunch({ url });
                return;
            }
            loadedBridge?.navigateTo?.({ url });
        })
        .catch((error) => {
            console.warn("[miniprogram-bridge] reLaunch failed", error);
        });
}

export function navigateMiniProgramLogout() {
    postMiniProgramMessage({ type: "logout" });
    reLaunchMiniProgram("/pages/index/index?login=1");
}
